import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { CmsEntities } from 'client/data/models/cms';
import { ResearchEntry } from 'site-modules/editorial/components/top-rated/research-entry/research-entry';

export function MainContent({ entries, isMobile = false, className = null }) {
  return (
    <div className={classnames('main-content', className)}>
      {entries.map((entry, index) => {
        const key = `main-${entry.id}-${index}`;
        return <ResearchEntry key={key} entry={entry} isMobile={isMobile} />;
      })}
    </div>
  );
}

MainContent.propTypes = {
  entries: PropTypes.arrayOf(CmsEntities.Content).isRequired,
  isMobile: PropTypes.bool,
  className: PropTypes.string,
};
